import React from 'react';
import './schedule.scss';
import { translate } from "react-translate";

class Schedule extends React.Component {

  render() {
    return (
      <div className="component schedule">
        <h4 className="schedule_title capsFont">{ this.props.t('schedule') }</h4>

        <div className="schedules">
          <div className="schedule_col first">
            <div className="start">
              <div className="date capsFont">
                <span className="day">19</span>&nbsp;&nbsp;
                <span className="month">{ this.props.t('month') }</span>
              </div>
            </div>

            <div className="list bodyFont">
              <div className="head">{ this.props.t('head') }: <strong>{ this.props.t('head_name') }</strong></div>
              <table>
                <tbody>
                  <tr>
                    <td className="time_col">09:00 - 10:00</td>
                    <td className="desc_col">{ this.props.t('registration') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">
                      <span>10:00 - 10:10</span>
                      <p style={{ textDecoration: 'underline' }}>{ this.props.t('session_start') }</p>
                    </td>
                    <td className="desc_col" dangerouslySetInnerHTML={{ __html: this.props.t('session1') }}></td>
                  </tr>
                  <tr>
                    <td className="desc_col" colSpan="2" style={{ textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, .1)' }}>{ this.props.t('moderator1') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">10:10 - 10:30</td>
                    <td className="desc_col">{ this.props.t('session2') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">10:30 - 10:45</td>
                    <td className="desc_col">{ this.props.t('session3') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">10:45 - 11:00</td>
                    <td className="desc_col">{ this.props.t('session4') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">11:00 - 11:10</td>
                    <td className="desc_col">{ this.props.t('session4_1') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">11:10 - 11:20</td>
                    <td className="desc_col">{ this.props.t('faq') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">11:20 - 12:00</td>
                    <td className="desc_col">{ this.props.t('coffee_break') }</td>
                  </tr>
                  <tr>
                    <td className="desc_col" colSpan="2" style={{ textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, .1)' }}>{ this.props.t('moderator2') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">12:00 - 12:30</td>
                    <td className="desc_col">{ this.props.t('session5') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">12:30 - 12:45</td>
                    <td className="desc_col">{ this.props.t('session6') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">12:45 - 13:00</td>
                    <td className="desc_col">{ this.props.t('session7') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">13:00 - 13:10</td>
                    <td className="desc_col">{ this.props.t('faq') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">13:10 - 13:30</td>
                    <td className="desc_col">{ this.props.t('session8') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">13:30 - 13:45</td>
                    <td className="desc_col">{ this.props.t('session9') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">13:45 - 14:00</td>
                    <td className="desc_col">{ this.props.t('session10') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">14:00 - 14:15</td>
                    <td className="desc_col">{ this.props.t('session11') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">14:15 - 14:25</td>
                    <td className="desc_col">{ this.props.t('faq') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">14:25 - 15:30</td>
                    <td className="desc_col">{ this.props.t('lunch') }</td>
                  </tr>
                  <tr>
                    <td className="desc_col" colSpan="2" style={{ textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, .1)' }}>{ this.props.t('moderator3') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">15:30 - 15:45</td>
                    <td className="desc_col">{ this.props.t('session11_1') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">15:45 - 16:05</td>
                    <td className="desc_col">{ this.props.t('session12') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">16:05 - 16:20</td>
                    <td className="desc_col">{ this.props.t('session13') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">16:20 - 16:35</td>
                    <td className="desc_col">{ this.props.t('session14') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">16:35 - 16:45</td>
                    <td className="desc_col">{ this.props.t('faq') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">16:45 - 17:05</td>
                    <td className="desc_col">{ this.props.t('session15') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">17:05 - 17:20</td>
                    <td className="desc_col">{ this.props.t('session16') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">17:20 - 17:35</td>
                    <td className="desc_col">{ this.props.t('session17') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">17:35 - 17:50</td>
                    <td className="desc_col">{ this.props.t('session18') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">17:50 - 18:00</td>
                    <td className="desc_col">{ this.props.t('faq') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">18:00 - 18:10</td>
                    <td className="desc_col">{ this.props.t('closing') }</td>
                  </tr>
                  <tr>
                    <td className="time_col">20:00</td>
                    <td className="desc_col">{ this.props.t('gala') }</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <br />

            <div className="start">
              <div className="date capsFont">
                <span className="day">20</span>&nbsp;&nbsp;
                <span className="month">{ this.props.t('month') }</span>
              </div>
            </div>

            <div className="list bodyFont">
              <table>
                <tbody>
                  <tr>
                    <td className="desc_col">{ this.props.t('kakheti') }</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default translate('Schedule')(Schedule);
